<button type="button"
        [disabled]="disabled()"
        [attr.aria-label]="ariaLabel()"
        class="flex items-center cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
  <div class="rounded-full w-5 h-5 flex items-center justify-center text-white text-lg font-medium"
       [class]="badgeClass()">
    <i class="fa-solid fa-2xs" [class]="glyphClass()"></i>
  </div>
</button>
